// @ts-nocheck
import React, { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import { useParams } from "react-router";
import { Box, CircularProgress } from "@material-ui/core/";
import api from "../../api";
import Registration from "./Registration";
import RegistrationText from "./RegistrationText";

const LOADING = "LOADING";
const TOKEN_ERROR = "TOKEN_ERROR";
const USER_NOT_FOUND = "USER_NOT_FOUND";
const USER_REGISTERED = "USER_REGISTERED";
const USER_NOT_REGISTERED = "USER_NOT_REGISTERED";
const USER_REGISTER = "USER_REGISTER";

const checkUser = (email) =>
  api.post("public/v1/users/check-registered", { email });

const RegistrationPage = () => {
  const params = useParams();
  const [renderState, setRenderState] = useState(LOADING);
  const [error, setError] = useState();

  useEffect(() => {
    try {
      const jwtData = jwtDecode(params.token);
      checkUser(jwtData.email)
        .then(({ data }) => {
          if (data) {
            setRenderState(USER_REGISTERED);
          } else {
            setRenderState(USER_NOT_REGISTERED);
          }
        })
        .catch((error) => {
          console.log(error);
          setRenderState(USER_NOT_FOUND);
        });
    } catch (e) {
      setRenderState(TOKEN_ERROR);
      setError(e.message);
    }
  }, [params]);

  switch (renderState) {
    case LOADING:
      return (
        <Box
          p={2}
          width={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <CircularProgress size="200px" />
        </Box>
      );
    case USER_NOT_FOUND:
      return (
        <RegistrationText message="User not found or the link is broken" />
      );
    case TOKEN_ERROR:
      return <RegistrationText message={error} />;
    case USER_REGISTER:
      return <RegistrationText message="User successfully registered" />;
    case USER_REGISTERED:
      return <RegistrationText message="User is already registered" />;
    case USER_NOT_REGISTERED:
      return (
        <Registration
          jwtData={jwtDecode(params.token)}
          setRenderState={setRenderState}
          USER_REGISTER={USER_REGISTER}
          USER_NOT_FOUND={USER_NOT_FOUND}
          params={params}
        />
      );
  }
};

export default RegistrationPage;
